import React, { useContext } from 'react';
import { number, string, shape, arrayOf } from 'prop-types';

import { PriceBlock } from '../PriceBlock/PriceBlock';
import { ToolContext } from '../../context/tool-context';

import './price-bar.scss';

export const PriceBar = ({ rentalPrices }) => {
  const tool = useContext(ToolContext);
  const isAVehicle = tool.isAVehicle();

  const mapPricingBlocks = () => {
    return (rentalPrices && rentalPrices.map((price, index) => (
      <PriceBlock rentalPrice={price} key={index} />
    )));
  };

  return (
    <div className="price-bar">
      <div className="price-container">
        {mapPricingBlocks()}
      </div>
      {isAVehicle && <div className="mileage-text green">Unlimited mileage on all vehicles</div>}
    </div>
  );
};

PriceBar.displayName = 'RentalPrice';

PriceBar.propTypes = {
  rentalPrices: arrayOf(
    shape({
      price: number.isRequired,
      duration: string.isRequired,
      promotion: string
    }).isRequired,
  ).isRequired
};